export const USER_MANAGEMENT = {
    HEADING: {
        TITLE: 'Users Management',
        DESCRIPTION: "",
    },
    FILTERS: {
        APP_TYPE: {
            PLACEHOLDER: "Auracle Life"
        },
        SEARCH: {
            PLACEHOLDER: "Search User/Mail"
        }
    },
    DELETE: {
        TITLE: "Delete User",
        DESCRIPTION: "Are you sure you want to delete this user?"
    },
    SELECT_APP_USERTYPE: {
        HEADING: {
            TITLE: 'Add User',
            DESCRIPTION: "",
        },
        BUTTONS: {
            TITLE: 'Add User'
        }
    },
    ADD_USER: {
        BACK: {
            TITLE: 'Add User',
            DESCRIPTION: 'Back to user management list',
        },
        HEADING: {
            TITLE: 'User Details',
            DESCRIPTION: "",
        },
        BUTTONS: {
            TITLE: 'Add User'
        },
        UPLOAD: {
            TITLE: 'User Image'
        }
    },
    EDIT_USER: {
        BACK: {
            TITLE: 'Edit User',
            DESCRIPTION: 'Back to view user',
        },
        HEADING: {
            TITLE: 'User Details',
            DESCRIPTION: "",
        },
        SUB_HEADING: {
            TITLE: 'User Profile Details',
            DESCRIPTION: "",
        },
        PROFILE_DETAILS: {
            TITLE: 'Astrology Profiles',
            DESCRIPTION: "",
        },
        BUTTONS: {
            TITLE: 'Update User'
        },
        UPLOAD: {
            TITLE: 'User Image'
        }
    },
    VIEW_USER: {
        BACK: {
            TITLE: 'View User',
            DESCRIPTION: 'Back to normal user list',
        },
        HEADING: {
            TITLE: 'User Profile Details',
            DESCRIPTION: "",
        },
        BUTTONS: {
            TITLE: 'Add User'
        },
        UPLOAD: {
            TITLE: 'User Image'
        }
    },
    UPDATE_ASTROLOGY_PROFILE: {
        HEADING: {
            TITLE: 'Update Astrology Profile Details',
            DESCRIPTION: "",
        },
        BUTTONS: {
            TITLE: 'Update Profile'
        },
    },
    ADD_ASTROLOGY_PROFILE: {
        HEADING: {
            TITLE: 'Add Astrology Profile',
            DESCRIPTION: "",
        },
        BUTTONS: {
            TITLE: 'Add Profile'
        },
    }
}